var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgBlueSquares = function SvgBlueSquares(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 26",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1,
    y: 1.5,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#021126"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 5,
    y: 5.5,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#0B3773"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 10,
    y: 9.5,
    width: 14,
    height: 14,
    rx: 1,
    fill: "#1E78F5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlueSquares);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNSAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgb3BhY2l0eT0iMC42IiB4PSIxIiB5PSIxLjUiIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHJ4PSIxIiBmaWxsPSIjMDIxMTI2Ii8+CjxyZWN0IG9wYWNpdHk9IjAuNiIgeD0iNSIgeT0iNS41IiB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHJ4PSIxIiBmaWxsPSIjMEIzNzczIi8+CjxyZWN0IG9wYWNpdHk9IjAuNiIgeD0iMTAiIHk9IjkuNSIgd2lkdGg9IjE0IiBoZWlnaHQ9IjE0IiByeD0iMSIgZmlsbD0iIzFFNzhGNSIvPgo8L3N2Zz4K";